import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Grid, Button } from '@mui/material';
import data from 'data/declaracoes.json'; // Ajuste o caminho se necessário
import logoCNM from 'Imagens/logo-cnm-rodape.png'

const Declaracoes = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    setEvents(data);
  }, []);

  return (
    <Container maxWidth="lg" style={{ padding: '2rem', minHeight: '64vh' }}>
      <Box sx={{ textAlign: 'center', marginBottom: '2rem' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Declarações
        </Typography>
        <Typography variant="body1" paragraph>
          Aqui você pode acessar as declarações dos eventos que participou.
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {events.map((event, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box sx={{
              bgcolor: '#f5f5f5',
              padding: '1.5rem',
              borderRadius: '8px',
              textAlign: 'center',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              transition: 'transform 0.2s',
              '&:hover': {
                transform: 'scale(1.05)'
              }
            }}>
                <img src={logoCNM} alt=''/>
              <Typography variant="h6" component="h2" gutterBottom>
                {event.title}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                href={event.link}
                target="_blank"
              >
                Retirar Declaração
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Declaracoes;
